// 文字数をカウント
export const countChar = (text, countSpaces, countLineBreaks) => {
  return text.split('').filter(char => {
    if (!countSpaces && (char === ' ' || char === '\u3000')) return false;
    if (!countLineBreaks && (char === '\n' || char === '\r')) return false;
    return true;
  }).length;
};

// 文字コードに応じたバイト数をカウント
export const getByteCount = (str, encoding) => {
  switch (encoding) {
    case 'UTF-8':
      return new TextEncoder().encode(str).length;
    case 'Shift_JIS':
      // Shift_JISの場合の概算
      return str.split('').reduce((acc, char) => {
        const code = char.charCodeAt(0);
        // 半角文字
        if (code < 0x80) return acc + 1;
        // 全角文字
        if ((0xff61 <= code && code <= 0xff9f)) return acc + 1;
        // その他（漢字など）
        return acc + 2;
      }, 0);
    case 'EUC-JP':
      // EUC-JPの場合の概算
      return str.split('').reduce((acc, char) => {
        const code = char.charCodeAt(0);
        // 半角文字
        if (code < 0x80) return acc + 1;
        // その他（全角文字）
        return acc + 2;
      }, 0);
    default:
      return new TextEncoder().encode(str).length;
  }
};

export const getReadingTime = (text, wordsPerMinute) => {
  const wordCount = countChar(text, false, false);
  return Math.ceil((wordCount / wordsPerMinute) * 60);
};
